const NetInfo = () => {
    return <div>dsfsf</div>
}
export default NetInfo;